// The Past data requests nav badge. Kept apart from api.js so the route config can
// import it without pulling the page's other queries into the main bundle.
import { useQuery } from '@tanstack/react-query'
import { SITE_ADMIN_METER_HISTORY_SUMMARY } from '@/endpoints'
import axios from '@/lib/axios'
import { historyNavBadgeCount } from './historyAdminDisplay.js'

export const HISTORY_KEY = ['siteAdmin', 'meterHistory']
export const HISTORY_SUMMARY_KEY = [...HISTORY_KEY, 'summary']

export async function fetchHistorySummary() {
    return (await axios.get(SITE_ADMIN_METER_HISTORY_SUMMARY)).data
}

/**
 * Requests waiting on Power (to send, or overdue to chase), for the nav. Shares the
 * summary chips' cache entry, so a step taken on the page updates it too; otherwise it
 * refetches at most once a minute.
 */
export function useHistoryNavBadge() {
    const query = useQuery({
        queryKey: HISTORY_SUMMARY_KEY,
        queryFn: fetchHistorySummary,
        staleTime: 60_000
    })
    return historyNavBadgeCount(query.data)
}
